<template>
  <div>
    <second-page
      :asideTitle="asideTitle"
      :title="title"
      :currPrograma="currPrograma"
      :asideList="asideList"
      :currType="currType"
      :currPath="currPath"
      :routeKeepAlive="routeKeepAlive"
      :routeKeepChild="routeKeepChild"
      @titleChange="titleChange"
      @currProgramaChange="currProgramaChange"
      @currTypeChange="currTypeChange"
    ></second-page>
  </div>
</template>
<script>
import SecondPage from '../../components/SecondPage/index.vue'
export default {
  name: 'department',
  components: {
    SecondPage,
  },
  data() {
    return {
      asideTitle: '政策文件',
      title: '',
      currPrograma: '',
      asideList: [
        {
          id: 0,
          title: '国务院',
          child: [],
          showType: 'list',
        },
        {
          id: 1,
          title: '教育部',
          child: [],
          showType: 'list',
        },
        {
          id: 2,
          title: '教育厅',
          child: [],
          showType: 'list',
        },
        {
          id: 3,
          title: '市教育局',
          child: [],
          showType: 'list',
        },
        {
          id: 4,
          title: '学校',
          child: [],
          showType: 'list',
        },
        {
          id: 5,
          title: '部门',
          child: [],
          showType: 'list',
        },
      ],
      currType: 'list',
      currPath: '/document',
      routeKeepAlive: '',
      routeKeepChild: '',
    }
  },
  created() {
    this.routeKeepAlive = this.$route.query.keepalive
    this.routeKeepChild = this.$route.query.keepchild
    // this.title = this.asideList[0].title
    // if (this.asideList[0].child.length > 0) {
    //   this.currPrograma = this.asideList[0].child[0].title
    //   this.currType = this.asideList[0].child[0].showType
    // } else {
    //   this.currPrograma = ''
    //   this.currType = this.asideList[0].showType
    // }
  },
  methods: {
    // changeBread(two, three) {
    //   this.title = two
    //   this.currPrograma = three
    //   console.log('Document!!changeBread')
    // },
    // changeType(type) {
    //   this.currType = type
    //   console.log('Document!!changeType')
    // },
    titleChange(currVal) {
      this.title = currVal
    },
    currProgramaChange(currVal) {
      this.currPrograma = currVal
    },
    currTypeChange(currVal) {
      this.currType = currVal
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  width: 1100px;
  margin-left: calc(50% - 550px);
}
</style>
